export class MailLabelsDb {
  public static list = [
    {
      'id': 0,
      'handle': 'note',
      'title': 'PayPal',
      'icon': 'text-dark-blue',
      'color': 'bg-dark-blue text-white'
    },
    {
      'id': 1,
      'handle': 'paypal',
      'title': 'Upwork',
      'icon': 'text-danger',
      'color': 'badge-danger'
    },
    {
      'id': 2,
      'handle': 'invoice',
      'title': 'In-house',
      'icon': 'text-light-cyan',
      'color': 'bg-light-cyan text-white'
    },
    {
      'id': 3,
      'handle': 'amazon',
      'title': 'Clients',
      'icon': 'text-success',
      'color': 'badge-success'
    }
  ];
}
